import React from 'react';
import { CheckCircle, Clock, AlertCircle, Calendar } from 'lucide-react';

interface DeadlineStatsProps {
  overdueCount: number;
  todayCount: number;
  thisWeekCount: number;
  completedThisWeek?: number;
  completionRate?: number;
}

export function DeadlineStats({ 
  overdueCount, 
  todayCount, 
  thisWeekCount,
  completedThisWeek = 0,
  completionRate = 0 
}: DeadlineStatsProps) {
  const stats = [
    {
      label: 'Overdue',
      value: overdueCount,
      icon: AlertCircle,
      color: overdueCount > 0 ? 'text-red-600' : 'text-gray-400',
      bgColor: overdueCount > 0 ? 'bg-red-100' : 'bg-gray-100',
    },
    {
      label: 'Due Today',
      value: todayCount,
      icon: Clock,
      color: todayCount > 0 ? 'text-orange-600' : 'text-gray-400',
      bgColor: todayCount > 0 ? 'bg-orange-100' : 'bg-gray-100',
    },
    {
      label: 'This Week',
      value: thisWeekCount,
      icon: Calendar,
      color: 'text-blue-600',
      bgColor: 'bg-blue-100',
    },
    {
      label: 'Completion Rate',
      value: `${Math.round(completionRate)}%`,
      icon: CheckCircle,
      color: completionRate >= 80 ? 'text-green-600' : completionRate >= 50 ? 'text-yellow-600' : 'text-red-600',
      bgColor: completionRate >= 80 ? 'bg-green-100' : completionRate >= 50 ? 'bg-yellow-100' : 'bg-red-100',
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <div key={stat.label} className="bg-white rounded-lg p-4 border border-gray-200">
            <div className="flex items-center">
              <div className={`rounded-md p-2 ${stat.bgColor}`}>
                <Icon className={`h-5 w-5 ${stat.color}`} />
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-900">{stat.value}</p>
                <p className="text-xs text-gray-500">{stat.label}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}